import { Component, ElementRef, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Location} from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';

@Component({
  selector: 'fury-table-data-add-edit',
  templateUrl: './table-data-add-edit.component.html',
  styleUrls: ['./table-data-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class TableDataAddEditComponent implements OnInit {

  tableDataForm!: FormGroup;
  companyId!:any;
  constructor(
    private apiService: ApiService,
    public location: Location,
    private activateRoute: ActivatedRoute
  ) { 
    this.companyId = this.activateRoute.snapshot.params["id"];
    if(this.companyId){
      this.getCompanyDetails();
    }
  }

  ngOnInit(): void {
    this.formInit();
  }

  formInit(){
    this.tableDataForm = new FormGroup({
      companyName: new FormControl('', [Validators.required]),
      bbbReview: new FormControl('', [Validators.required, Validators.min(0), Validators.max(5)]),
      bbbAccredited: new FormControl('', [Validators.required]),
      bbbRating: new FormControl('', [Validators.required,]),
      bbbComplaints: new FormControl('', [Validators.required]),
      copayment: new FormControl('', [Validators.required,]),
      workGuarantee: new FormControl('', [Validators.required,]),
      coverage: new FormControl('', [Validators.required,]),
      applianceCaps: new FormControl('', [Validators.required,]),
      systemsCaps: new FormControl('', [Validators.required,]),
      maintenanceRecord: new FormControl('', [Validators.required,]),
      startingPrice: new FormControl('', [Validators.required,]),
      redirectUrl: new FormControl('', [Validators.required, Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=%.]+$/)]),
    })
  };
  getCompanyDetails(){
    this.apiService.get(`admin/home-warranty-company/get-home-warranty-company/${this.companyId}`).subscribe((res: any)=>{
      if(res?.body){
        this.tableDataForm.patchValue(res?.body?.homeWarrantyCompany);
      } 
    })
  }
  addEditTableData(){
    if(this.tableDataForm.valid){
      if(!this.companyId){
        this.apiService.post('admin/home-warranty-company/create-home-warranty-company', this.tableDataForm.value).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
            this.apiService.alert(err.message, ErrorType.Error);
          }
        })
      } else {
        this.apiService.patch(`admin/home-warranty-company/update-home-warranty-company/${this.companyId}`, this.tableDataForm.value).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
            this.apiService.alert(err.message, ErrorType.Error);
          }
        })
      }
    } else {
      this.tableDataForm.markAllAsTouched();
    }
  }
  numberCommaPlusOnly(event: any){
    const pattern = /^[0-9,+]+$/;
  if (pattern.test(event?.key)) {
    return { invalidInput: true };
  }
  return false;
  }

}
